<mat-horizontal-stepper *ngIf="isLoaded ; else loading" [linear]="isLinear" #stepper
  (selectionChange)="tabAsChange($event)" class="main-content mat-elevation-z4" [selectedIndex]="selectedIndex">
  <mat-step [stepControl]=formGroupArray[0] [editable]="isMatStepperEditable">
    <form [formGroup]=formGroupArray[0]>
      <ng-template matStepLabel>Identification</ng-template>
      <div>
        <div *ngIf="listSociety?.length > 1;" class="zoneSaisie">
          <mat-form-field>
            <mat-label>societé</mat-label>
            <mat-select (selectionChange)="setSociety($event)">
              <mat-option *ngFor="let society of listSociety " [value]="society">{{society.companyName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <ng-container *ngIf="societySelected != null">
          <mat-form-field class="singleTextField">
            <mat-label>Déclarant</mat-label>
            <mat-select formControlName="nom">
              <mat-option *ngFor="let user of userList" [value]="user.idUnique" required>{{user.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </div>
      <div class="buttonsRight">
        <button matButton="filled" matStepperNext>Suivant</button>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]=formGroupArray[1] [editable]="isMatStepperEditable">
    <form [formGroup]=formGroupArray[1]>
      <ng-template matStepLabel>Description</ng-template>
      <div>
        <mat-form-field class="singleTextField">
          <input matInput placeholder="Sujet" formControlName="sujet" required>
          <mat-error>
            Minimum 5 caratères
          </mat-error>
        </mat-form-field>

      </div>
      <div>
        <mat-form-field class="textAreaField">
          <textarea matInput placeholder="Décrivez la demande de support" formControlName="description" required
            MatFormFieldAppearance="fill" class="textAreaField"></textarea>
          <mat-error>
            champs requis
          </mat-error>
        </mat-form-field>
      </div>
      <div class="buttonsRight">
        <button matButton="filled" matStepperPrevious class="buttonForm">Précédent</button>
        <button matButton="filled" matStepperNext  class="buttonForm" (click)="this.isMatStepperEditable = false;">Envoyer l'appel à support</button>
      </div>
    </form>
  </mat-step>
  <mat-step>
    <ng-template matStepLabel>Document(s) complémentaire</ng-template>
    <div class="titleMessage">Votre appel à support a été transmis, vous pouvez maintenant y adjoindre des documents
    </div>
    <app-envoi-fichier [idDecalrationappelASupport]=identifiantWebappelASupport
      (filesSended)="updateFilesSended($event)">
    </app-envoi-fichier>
    <div class="button-right-end-declaration">
      <button matButton="filled" class="buttonForm" [disabled]="!canValidate" (click)="validStepper()">
        Terminer ma déclaration</button>
    </div>
  </mat-step>
</mat-horizontal-stepper>
<ng-template #loading>
  <div class="loading">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>